import { make } from 'vuex-pathify'

const state = {
  data: {},
}

const mutations = make.mutations(state)

const getters = {}

const actions = {}

export const lostProperties = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
